export default "__VITE_ASSET__412c530d__"